// Ids of the drawer titles the option groups inside the drawers are named by.
// Only one review drawer can be open at a time, so plain constants are enough.
export const SORTING_DRAWER_TITLE_ID = 'reviewsSortingDrawerTitle';
export const FILTER_DRAWER_TITLE_ID = 'reviewsFilterDrawerTitle';
